export var FormTemplateStatus;
(function (FormTemplateStatus) {
    FormTemplateStatus["Draft"] = "draft";
    FormTemplateStatus["Published"] = "published";
})(FormTemplateStatus || (FormTemplateStatus = {}));
//# sourceMappingURL=FormTemplate.interface.js.map